module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetHigh@2x.f13901c.webp";